<ng-container *ngIf="entity">
  <div class="entity__status"
       *ngIf="entity.linkedUserId">
    <i class="fas fa-user spacerRight"></i>
    <span class="entity__statusName">{{entity.firstName }}</span> is a user.
    <a class="entity__statusLink entity__statusLink--mute color--magenta ml-0025"
       routerLink="/admin/account/edit/{{entity.linkedUserId}}"
       *appIfMinRole="'organizer'">
      <strong>Edit</strong>
    </a>
  </div>

  <div class="entity__status"
       *ngIf="!entity.linkedUserId">
    <span class="entity__statusName">{{entity.firstName }}</span> is not a user.
    <span class="entity__statusLink c-pointer ml-0025"
          (click)="onPromoteToUserClicked()"
          *appIfMinRole="'organizer'">Promote
      <i class="fas fa-arrow-circle-up ml-0025"></i>
    </span>
  </div>
</ng-container>
